/**
 * UPLOAD WIZARD REDUX ACTIONS
 *
 * Description here.
 *
 * @version 0.1
 */

import reduxStore from './../../reduxStore';
import xhr from './../../utils/xhr';
import utils from './../../utils/utilities';

// Define action constants
export const DASHBOARD_RESET = "DASHBOARD_RESET";
export const DASHBOARD_NO_COMPANIES = 'DASHBOARD_NO_COMPANIES';
export const DASHBOARD_WITH_COMPANIES = 'DASHBOARD_WITH_COMPANIES';
export const DASHBOARD_INFO_RECEIVED = 'DASHBOARD_INFO_RECEIVED';
export const HIDE_DASHBOARD_SPINNER = 'HIDE_DASHBOARD_SPINNER';
export const SHOW_DASHBOARD_SPINNERS = 'SHOW_DASHBOARD_SPINNERS';
export const DASHBOARD_CHANGE_FILTER = 'DASHBOARD_CHANGE_FILTER';

const actions = {

    dashboardReset: () => {
        reduxStore.dispatch({type: DASHBOARD_RESET});
    },

    getCompanyInfo: () => {

        reduxStore.dispatch({type: 'HIDE_SPINNER'});

        return xhr.get({
            url:     '/api/entities/companies/count'
        }).then((response) => {
            reduxStore.dispatch({type: 'HIDE_SPINNER'});

            if (response.body === 0) {
                reduxStore.dispatch({type: 'DASHBOARD_NO_COMPANIES'});
            } else {
                reduxStore.dispatch({type: 'DASHBOARD_WITH_COMPANIES'});
            }
        }).catch((error) => {
            utils.logError(error, 'StartPage.actions.getCompanyInfo():');
            xhr.handleAllErrors(error);
        });
    },

    getActiveCount:() => {
        return xhr.get({
            url:     '/api/entities/companies/active/count'
        }).then((response) => {
            reduxStore.dispatch({type: 'DASHBOARD_INFO_RECEIVED', payload: {active: response.body}});
            reduxStore.dispatch({type: 'HIDE_DASHBOARD_SPINNER', payload: 'manageSpinner'});
        }).catch((error) => {
            utils.logError(error, 'StartPage.actions.getActiveCount():');
            xhr.handleAllErrors(error);
        });
    },

    getInactiveCount:() => {
        return xhr.get({
            url:     '/api/entities/companies/non-active/count'
        }).then((response) => {
            reduxStore.dispatch({type: 'DASHBOARD_INFO_RECEIVED', payload: {inactive: response.body}});
            reduxStore.dispatch({type: 'HIDE_DASHBOARD_SPINNER', payload: 'activateSpinner'});
        }).catch((error) => {
            utils.logError(error, 'StartPage.actions.getInactiveCount():');
            xhr.handleAllErrors(error);
        });
    },

    getFeedsCount:() => {
        return xhr.get({
            url:     '/api/feeds/count/RMM'
        }).then((response) => {
            // The response body is a long
            reduxStore.dispatch({type: 'DASHBOARD_INFO_RECEIVED', payload: {rss: response.body}});
            reduxStore.dispatch({type: 'HIDE_DASHBOARD_SPINNER', payload: 'shareSpinner'});
        }).catch((error) => {
            utils.logError(error, 'StartPage.actions.getFeedsCount():');
            xhr.handleAllErrors(error);
        });
    },

    getSubscription:() => {
        return xhr.get({
            url:     '/api/customer/subscription'
        }).then((response) => {
            reduxStore.dispatch({
                type: 'DASHBOARD_INFO_RECEIVED',
                payload: {
                    subscription: response.body.maximumNoOfThirdParties
                }
            });
        }).catch((error) => {
            utils.logError(error, 'StartPage.actions.getSubscription():');
            xhr.handleAllErrors(error);
        });
    },

    setSpinners: () => {
        reduxStore.dispatch({type: 'SHOW_DASHBOARD_SPINNERS'});
    },

    getAllData: ()=> {
        return Promise.all([
            actions.getCompanyInfo(),
            actions.getActiveCount(),
            actions.getInactiveCount(),
            actions.getFeedsCount(),
            actions.getSubscription()
        ])
            .then(() => {reduxStore.dispatch({type: 'HIDE_DASHBOARD_SPINNER', payload: 'addSpinner'})})
            .catch((error) => {
                utils.logError(error, 'StartPage.actions.getAllData():');
                xhr.handleAllErrors(error);
            });
    }
};

export default actions;


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/StartPage.actions.js